import { Pipe, PipeTransform } from '@angular/core';
import {
    IHistoryFilter,
    IHistoryFilterItem,
} from '../interfaces/history.interfaces';

@Pipe({
    name: 'searchFilter',
    standalone: false
})
export class SearchFilterPipe implements PipeTransform {
    public transform(items: any[], searchFilter: string): any[] {
        if (!items) return [];
        if (!searchFilter) return items;

        searchFilter = searchFilter.toLocaleLowerCase();

        return items.filter((item) =>
            item.text.toLocaleLowerCase().includes(searchFilter)
        );
    }
}
